import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { VscLoading } from "react-icons/vsc";
import { useHistory } from "react-router";
import { IoCloseOutline, IoCheckmark, IoTrashOutline } from "react-icons/io5";
import axios from "axios";
import Cookies from "js-cookie";
import Modal from "../../modals/Modal";
import actionButtonsToggle from "../../helpers/actionButtonsToggle";


window.addEventListener("click", function (e) {
	e.stopPropagation()
	let icon = document.getElementsByClassName('dotsNoty')
	if (icon) {
		actionButtonsToggle(e, ...icon)
	}
})


const Notification = ({ isOpen, hideModal , handleFetchNotificationsCount }) => {
    const [notifications, setNotifications] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingReadAll, setIsLoadingReadAll] = useState(false);
    const [offset, setOffset] = useState(0);
    const [limit] = useState(10);
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const scrollRef = useRef(null);
    const userSelector = useSelector(state => state.userReducer);
    const history = useHistory();

    useEffect(() => {
        if(!userSelector?.user) return;
        if(isOpen){
            setIsLoading(true);
            setNotifications([]);
            setOffset(0);
            setHasMore(true);
            handleFetchNotifications(0, limit, true);
        }
    },[isOpen,userSelector?.user, limit]);

    const handleFetchNotifications = useCallback((startOffset = offset, pageLimit = limit, replace = false) => {
        return fetchNotifications(startOffset, pageLimit).then((data) => {
            const list = data.allNotifications || [];
            setNotifications(prev => {
                if (replace) return list;
                const existing = new Map(prev.map(n => [n.id, n]));
                list.forEach(n => existing.set(n.id, n));
                return Array.from(existing.values());
            });
            setIsLoading(false);
            if (list.length < pageLimit) {
                setHasMore(false);
            }
            setOffset(startOffset + list.length);
        });
    }, [offset, limit]);

    const onScroll = useCallback((e) => {
        const el = e.currentTarget;
        if (!hasMore || isLoadingMore || isLoading) return;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
            setIsLoadingMore(true);
            handleFetchNotifications(offset, limit).finally(() => setIsLoadingMore(false));
        }
    }, [hasMore, isLoadingMore, isLoading, handleFetchNotifications, offset, limit]);


    const handleClickOnlyBackdrop = (event) => {
		if (event.target.classList.contains('modal-b3')) {
			event.preventDefault();
			event.stopPropagation();
			hideModal();
            handleFetchNotificationsCount && handleFetchNotificationsCount();
		}
	}

    const markAllRead = async (e) => {
        setIsLoadingReadAll(true);
        axios.get('/api/notifications/mark-read',{ headers: { Authorization: `Bearer ${Cookies.get('access_token')}` } } ).then(()=>{
            setOffset(0);
            setHasMore(true);
            handleFetchNotifications(0, limit, true);
            handleFetchNotificationsCount && handleFetchNotificationsCount();
            setIsLoadingReadAll(false);
            hideModal();
        });
    }

    return (
		isOpen && (
			<Modal>
				<div onClick={handleClickOnlyBackdrop} className="modal d-block modal-b3">
					<div className="notification-modal">
						<div className="modal-body p-0">
							<nav>
								<div className="d-flex justify-content-between" id="notification-tab" role="tablist">
									<h5>Notifications</h5>
									<button type="button" className="btn-primary-menus me-4" onClick={(e) => markAllRead(e)}>
                                        Mark all as Read
                                        {isLoadingReadAll ? <VscLoading size={18} className="ms-1 spin-loading" /> : <IoCheckmark className="ms-1" size={18} />}
                                    </button>
									<IoCloseOutline onClick={hideModal} className="hidemodal-notify" />
								</div>
							</nav>
							<div className="tab-content" id="nav-tabContent" ref={scrollRef} onScroll={onScroll}>

                                {isLoading && <div className=" text-center my-4">
                                    <div className="spinner-border"></div>
                                    <div>Fetching<div className="loading-dots"></div></div>
                                </div>}

                                {notifications.length > 0 && notifications.map((notification, index) => (
                                    <NotificationItem
                                        key={notification.id || index}
                                        notification={notification}
                                        history={history}
                                        setNotifications={setNotifications}
                                        hideModal={hideModal}
                                        onAfterDismiss={(newCount) => {
                                            if (hasMore && !isLoading && !isLoadingMore && newCount <= Math.max(5, limit - 1)) {
                                                setIsLoadingMore(true);
                                                handleFetchNotifications(offset, limit).finally(() => setIsLoadingMore(false));
                                            }
                                        }}
                                    />
                                ))}

                                {notifications.length == 0 && !isLoading && (<div className="text-center my-4">No Notifications</div>)}

                                {isLoadingMore && <div className=" text-center my-3">
                                    <div className="spinner-border spinner-border-sm"></div>
                                </div>}
							</div>
						</div>
					</div>
				</div>
			</Modal>
		)
	)
}

function NotificationItem({ notification, history, setNotifications, hideModal, onAfterDismiss }){
    const [isNew, setIsNew] = useState(notification.read_at === null);
    const userName = notification?.user?.name ?? notification?.user?.email ?? 'System';
    const ticketTitle = notification?.ticket?.title ?? '';
    const ticketId = notification?.ticket?.id;
    const imgSrc = "https://ui-avatars.com/api/?name=" + encodeURIComponent(userName || '00');

    function markRead() {
        setIsNew(false);
        axios.get('/api/notifications/mark-read?id=' + notification.id, { headers: { Authorization: `Bearer ${Cookies.get('access_token')}` } });
    }

    function goToTicket() {
        markRead();
        hideModal && hideModal();
        if (notification?.url) {
            try {
                // If absolute URL, navigate directly to ensure it works in all setups
                if (/^https?:\/\//i.test(notification.url)) {
                    window.location.assign(notification.url);
                } else {
                    history.push(notification.url);
                }
            } catch (e) {
                // Fallback to in-app route using ticketId
                if (ticketId) history.push(`/ticket/${ticketId}`);
            }
        } else if (ticketId) {
            history.push(`/ticket/${ticketId}`);
        } else {
            console.error('Ticket ID/URL not found in notification data.');
        }
    }

    function dismiss(){
        // Optimistically remove from UI and maybe top-up
        setNotifications(prev => {
            const updated = prev.filter(n => n.id !== notification.id);
            try { onAfterDismiss && onAfterDismiss(updated.length); } catch (e) {}
            return updated;
        });
        // Call API to delete
        axios.delete(`/api/notifications/${notification.id}`, { headers: { Authorization: `Bearer ${Cookies.get('access_token')}` } })
            .catch(() => {
                // Revert if failed
                setNotifications(prev => {
                    const exists = prev.find(n => n.id === notification.id);
                    return exists ? prev : [notification, ...prev];
                });
            });
    }

    const content = (() => {
        switch (notification.type) {
            case 'new-ticket':
                return (
                    <>
                        <p className="mb-0"><b>{userName}</b> created new ticket</p>
                        <p className="mb-0">Ticket: "{ticketTitle}"</p>
                    </>
                );
            case 'status-updated': {
                const from = notification.old_status;
                const to = notification.new_status;
                const fromColor = notification.old_status_color || '#888';
                const toColor = notification.new_status_color || '#888';
                return (
                    <>
                        <p className="mb-0"><b>{userName}</b> updated ticket status</p>
                        <div className="mb-0">
                            <span className="badge me-1" style={{backgroundColor: fromColor}}>{from}</span>
                            <span className="mx-1">→</span>
                            <span className="badge" style={{backgroundColor: toColor}}>{to}</span>
                        </div>
                        <p className="mb-0">{ticketTitle}</p>
                    </>
                );
            }
            case 'assignees-updated': {
                const addedCount = Array.isArray(notification.added) ? notification.added.length : 0;
                return (
                    <>
                        <p className="mb-0"><b>{userName}</b> updated assignees</p>
                        <p className="mb-0">Added {addedCount} assignee(s)</p>
                        <p className="mb-0">{ticketTitle}</p>
                    </>
                );
            }
            case 'reply-created': {
                return (
                    <>
                        <p className="mb-0"><b>{userName}</b> replied on ticket</p>
                        <p className="mb-0 text-truncate">{notification.comment_preview}</p>
                        <p className="mb-0">{ticketTitle}</p>
                    </>
                );
            }
            case 'note-created': {
                return (
                    <>
                        <p className="mb-0"><b>{userName}</b> added a note</p>
                        <p className="mb-0 text-truncate">{notification.comment_preview}</p>
                        <p className="mb-0">{ticketTitle}</p>
                    </>
                );
            }
            default:
                return (
                    <>
                        <p className="mb-0">Notification</p>
                        <p className="mb-0">{ticketTitle}</p>
                    </>
                );
        }
    })();

    return (
        <div className={`d-flex align-items-center p-2 ${isNew ? 'bg-info-subtle' : ''}`}>
            <img src={imgSrc} className="rounded img-thumbnail" alt="avatar" style={{"--bs-border-radius": "50%"}} />
            <div className="flex-1 px-1 min-w-0">
                {content}
            </div>
            <div className="ms-2">
                <button onClick={goToTicket} className="btn btn-primary mr-1">View</button>
                <button onClick={dismiss} className="btn btn-danger"><IoTrashOutline /></button>
            </div>
        </div>
    );
}



async function fetchNotifications(offset = null,limit = null){
    const token = Cookies.get('access_token');
    const params = new URLSearchParams();
    params.append('offset', offset ?? 0);
    params.append('limit', limit ?? 10);

    const response = await axios.get(`/api/notifications?${params.toString()}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response?.data || [];
}



export default Notification
